(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Inspiration-life-series"] && !Shopify.designMode) return;
  try {
    
  const container = document.querySelector('.inspiration_life_series_contain');

  container.querySelectorAll('.contain_item').forEach((item) => {
    item.addEventListener('click', () => {
      const first = container.firstElementChild;

      if (item === first) return;

      const placeholder = document.createTextNode('');

      container.replaceChild(placeholder, item);
      container.replaceChild(item, first);
      container.replaceChild(first, placeholder);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    $(function () {
      const $slider = $('.announcement-bar-slider');

      if (!$slider.length) return;

      $slider.each(function () {
        const $this = $(this);
        const autoplay = $this.find('.slider--everywhere').data('autoplay') === true;
        const speedSeconds = parseFloat($this.find('.slider--everywhere').data('speed')) || 3;

        $this.find('.slider--everywhere').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false, // 如果要关闭分页点可以设为 false
          arrows: false,
          autoplay: autoplay,
          autoplaySpeed: speedSeconds * 1000,
          pauseOnHover: true,
          pauseOnFocus: false,
          adaptiveHeight: true,
          cssEase: 'linear',
          verticalSwiping: true,
          vertical: true,
        });

        // 当鼠标悬浮暂停、移出恢复
        $this
          .on('mouseenter', function () {
            $this.find('.slider--everywhere').slick('slickPause');
          })
          .on('mouseleave', function () {
            if (autoplay) $this.find('.slider--everywhere').slick('slickPlay');
          });
      });
    });
  })(jQuery);

  document.querySelector('.header-contact').addEventListener('click', () => {
    document.querySelector('.help_modal_btn').click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelector('.header_search_box').addEventListener('click', (e) => {
    const searchModal = document.querySelector('.header_search_box details-modal');
    const details = searchModal.querySelector('details');
    if (!details.hasAttribute('open')) {
      e.preventDefault();
      e.stopPropagation();
      searchModal.open({ target: details.querySelector('summary') });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-modal"] && !Shopify.designMode) return;
  try {
    
  // 打开/关闭 modal
  const helpBtn = document.querySelector('.help_modal_btn');
  const modalBox = document.querySelector('.help_modal_box');
  const headBack = document.querySelector('.help_modal_box_head_back');
  const headClose = document.querySelector('.help_modal_box_head_close');

  helpBtn.addEventListener('click', () => {
    modalBox.classList.toggle('hidden');
    helpBtn.classList.add('hidden');
    resetToMainMenu();
  });

  // 关闭按钮
  headClose.addEventListener('click', () => {
    modalBox.classList.add('hidden');
    helpBtn.classList.remove('hidden');
    resetToMainMenu();
  });

  // 复用函数：回到第一层
  function resetToMainMenu() {
    headBack.classList.add('hidden');

    document.querySelectorAll('.help_modal_box_body_section1').forEach((el) => {
      el.classList.remove('hidden');
    });

    document.querySelectorAll('.help_modal_box_body_form').forEach((el) => {
      el.classList.add('hidden');
    });
  }

  // 点击返回箭头
  headBack.addEventListener('click', () => {
    resetToMainMenu();
  });

  // 绑定第一层选择事件
  document.querySelectorAll('.help_modal_box_body_section1_item').forEach((item) => {
    item.addEventListener('click', () => {
      const type = item.getAttribute('data-type');

      // 显示返回箭头
      headBack.classList.remove('hidden');

      // 隐藏选择菜单
      document.querySelector('.help_modal_box_body_section1').classList.add('hidden');

      // 显示对应的 form
      document.querySelectorAll('.help_modal_box_body_form').forEach((form) => {
        if (form.getAttribute('data-type') === type) {
          form.classList.remove('hidden');
        } else {
          form.classList.add('hidden');
        }
      });
    });
  });

  let parent;
  document.querySelectorAll('.help_modal_box_body_form_upload_box').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.help_modal #formUpload').click();
      parent = item.closest('.help_modal_box_body_form_upload');
    });
  });

  let uploadFileUrls = [];

  document.querySelector('.help_modal #formUpload').addEventListener('change', async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('shop_name', 'bulijojo');

    try {
      const res = await fetch('http://shopify.iwxjx.com/api/Upload/uploadImage', {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.code !== 200) {
        console.error('上传失败:', result);
        return;
      }

      const { url, filename, size } = result.data;

      // push 对象 { filename, url }
      uploadFileUrls.push({ filename, url });

      // ⭐ 同步写入 hidden input
      parent.querySelector('input[name="contact[attachments]"]').value = JSON.stringify(uploadFileUrls);

      const fileSizeKB = (size / 1024).toFixed(1) + ' kB';
      const container = parent.querySelector('.help_modal_box_body_form_upload_result');

      const item = document.createElement('div');
      item.className = 'product_info_upload_result_item';

      item.innerHTML = `
        <div>
          <div class="product_info_upload_result_item_title">${filename}</div>
          <div>${fileSizeKB}</div>
        </div>
        <svg
          stroke="currentColor"
          fill="currentColor"
          stroke-width="0"
          viewBox="0 0 20 20"
          aria-hidden="true"
          class="w-6 h-6 text-core-tree-100 upload_remove_btn"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      `;

      // 删除逻辑同步更新
      item.querySelector('.upload_remove_btn').addEventListener('click', () => {
        uploadFileUrls = uploadFileUrls.filter((fileObj) => fileObj.url !== url);

        // ⭐ 更新 contact[attachments]
        parent.querySelector('input[name="contact[attachments]"]').value = JSON.stringify(uploadFileUrls);

        item.remove();
      });

      container.appendChild(item);

      setTimeout(() => {
        item.classList.add('full');
      }, 0);
    } catch (err) {
      console.error('上传失败:', err);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-subscribe"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('.home_subscribe_btn').addEventListener('click', () => {
    document.querySelector('.home_subscribe_modal').classList.remove('hidden');
  });

  document.querySelector('.home_subscribe_modal_head_close').addEventListener('click', () => {
    document.querySelector('.home_subscribe_modal').classList.add('hidden');
  });

  document.querySelector('.home_subscribe_modal').addEventListener('click', (e) => {
    if (e.target == document.querySelector('.home_subscribe_modal')) {
      document.querySelector('.home_subscribe_modal').classList.add('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-category-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('.product_category_grid .quote_request_btn').addEventListener('click', () => {
    document.querySelector('.help_modal_btn').click();
  });

  } catch(e) { console.error(e); }
})();
})();
